"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function emailValidate(email) {
    return regexEmail.test(String(email).toLowerCase());
}
exports.default = emailValidate;
